module.exports = __webpack_public_path__ + "img/yabbr-logo-primary.91a6ee06.png";